module.exports = __webpack_public_path__ + "static/media/auv_bg.03c2e255.jpg";